import {useRef, useState} from "react";
import {defineMessage} from "react-intl";
import FormattedButton from "@/components/FormattedButton";
import {IntervalWidget} from "../IntervalWidget";
import {FormattedFormRow, FormContainer} from "@dvrt/graphql-widgets";
import {CallsInterval} from "./types";
import {NumberWidget} from "@/components/call-list/NumberWidget";
import deepEqual from "deep-equal";

export type SubmitAction = "search" | "download";

type Props = {
    onSubmit: (interval: CallsInterval, targetNumber: number, action: SubmitAction) => void;
    disabled: boolean;
    domainId: number;
    downloadEnabled: boolean;
};

type FilterVars = {
    interval: CallsInterval;
    targetNumber: number;
};

export const Filters = ({onSubmit, disabled, domainId, downloadEnabled}: Props) => {
    const [interval, setInterval] = useState<CallsInterval>("thisMonth");
    const [targetNumber, setTargetNumber] = useState<number>(0);
    const lastFilters = useRef<FilterVars>({interval, targetNumber});

    const onClickFactory = (action: SubmitAction) => () => {
        onSubmit(interval, targetNumber, action);
        lastFilters.current = {interval, targetNumber};
    };

    return (
        <FormContainer style={{gridTemplateColumns: "auto 1fr"}}>
            <FormattedFormRow
                label={defineMessage({id: "call_list.filters.interval.label", defaultMessage: "Interval"})}
            >
                <IntervalWidget interval={interval} setInterval={setInterval} disabled={disabled} />
            </FormattedFormRow>
            <FormattedFormRow label={defineMessage({id: "call_list.localNumber", defaultMessage: "Local number"})}>
                <NumberWidget
                    numberId={targetNumber}
                    setNumberId={setTargetNumber}
                    domainId={domainId}
                    disabled={disabled}
                />
            </FormattedFormRow>
            <FormattedFormRow>
                <FormattedButton
                    message={defineMessage({id: "search", defaultMessage: "Search"})}
                    onClick={onClickFactory("search")}
                    disabled={disabled}
                />
                <FormattedButton
                    variant="text"
                    message={defineMessage({id: "download", defaultMessage: "Download"})}
                    disabled={
                        disabled ||
                        !downloadEnabled ||
                        !deepEqual(lastFilters.current, {interval, targetNumber} as FilterVars)
                    }
                    style={{marginLeft: 15}}
                    onClick={onClickFactory("download")}
                />
            </FormattedFormRow>
        </FormContainer>
    );
};
